import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import Header from "@components/header/desktop/Header";
import CreateAdsComponent from "@components/ads/create/create-ads";
import { useAuth } from "@hooks/use-auth";

const CreateAds = () => {
  const { user } = useAuth();

  useEffect(() => {
    window.document.title = "Buat Iklan | PusaranMedia.com";
  }, []);

  return (
    <>
      <Header user={user} />
      <Container className="mt-5 pt-3">
        <Row>
          <Col xs={12} md={12}>
            <div className="table-responsive">
              <CreateAdsComponent />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateAds;
